import { useCallback } from "react"
import { updEventData } from "../../ReduxSlice/Event/eventSlice"
import { updNotification } from "../../ReduxSlice/Ui/UiSlice"
import useHttpHook from "../HttpHook"

const useEventThunk = () => {
    const [loading, sendRequest, error] = useHttpHook()
    return (url,config={}) => async (dispatch) => {
        dispatch(updNotification({loading:true}))
        let event = await sendRequest(url,config)
        dispatch(updNotification({loading:false}))
        dispatch(updEventData(event)) 
    }
}



export default useEventThunk